// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 20,
        loadProductFirst: false,
      	 capitalizeFilterOptionValues: false, 
         forceCapitalizeFilterOptionValues: false,
    },
  	label: {
        sorting: {
            'manual' : bcSfFilterConfig.label.sorting_featured, 
            'title-ascending': bcSfFilterConfig.label.sorting_title_ascending,
            'title-descending': bcSfFilterConfig.label.sorting_title_descending,
            'price-ascending' : bcSfFilterConfig.label.sorting_price_ascending, 
            'price-descending' : bcSfFilterConfig.label.sorting_price_descending,
            'created-descending': bcSfFilterConfig.label.sorting_date_descending, 
            'created-ascending': bcSfFilterConfig.label.sorting_date_ascending,
            'sale-descending': bcSfFilterConfig.label.sorting_sale_descending
        }
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'textCenterClass': 'text-center',
    'imageSoldOutClass': 'grid-link__image-sold-out',
 
    'largeSaleLabelHtml': '<span class="badge badge--sale"><span class="badge__text badge__text--small">' + bcSfFilterConfig.label.sale + '</span></span>',
    'smallSaleLabelHtml': '<span class="badge badge--sale"><span class="badge__text">' + bcSfFilterConfig.label.sale + '</span></span>',
    'largeSoldOutLabelHtml': '<span class="badge badge--sold-out"><span class="badge__text badge__text--small">' + bcSfFilterConfig.label.sold_out + '</span></span>',
    'smallSoldOutLabelHtml': '<span class="badge badge--sold-out"><span class="badge__text">' + bcSfFilterConfig.label.sold_out + '</span></span>',
    'vendorHtml': '<p class="grid-link__title grid-link__vendor">{{itemVendorLabel}}</p>',

    'productGridItemHtml': '<div class="grid__item wide--one-fifth large--one-quarter medium-down--one-half {{soldOutClass}} {{itemSaleClass}}">' +
                                '<a href="{{itemUrl}}" class="grid-link {{textCenterClass}}">' +
                                	'<span class="grid-link__image {{imageSoldOutClass}} grid-link__image--product">' +
                                        '{{itemSaleLabel}}' +
                                        '{{itemSoldOutLabel}}' +
                                        '<span class="grid-link__image-centered"><img src="{{itemThumbUrl}}" alt="{{itemTitle}}" /></span>' +
                                	'</span>' +
                                	'<p class="grid-link__title">{{itemTitle}}</p>' +
                                	'{{itemVendor}}' +
                                	'{{itemPrice}}' +
                                '</a>' +
  								'<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
                            '</div>',

    'previousActiveHtml': '<li><a href="{{itemUrl}}">←</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>←</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">→</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>→</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>',
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select>{{showLimitItems}}</select>',

    'breadcrumbHtml': '<nav class="breadcrumb" role="navigation" aria-label="breadcrumbs"><a href="/" title="Back to the frontpage">Home</a><span aria-hidden="true" class="breadcrumb__sep">â€º</span><span>{{itemSelected}}</span></nav>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
    // Prepare data
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available;
    var onSale = data.compare_at_price_min > data.price_min;
    var priceVaries = data.price_min != data.price_max;

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var itemSaleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);
  
    var textCenterClass = bcSfFilterConfig.custom.center_grid_link ? bcSfFilterTemplate.textCenterClass: '';
    itemHtml = itemHtml.replace(/{{textCenterClass}}/g, textCenterClass);

    var imageSoldOutClass = bcSfFilterConfig.custom.show_sold_out_circle ? bcSfFilterTemplate.imageSoldOutClass: '';
    itemHtml = itemHtml.replace(/{{imageSoldOutClass}}/g, imageSoldOutClass);
  
    // Add onSale label
    if (onSale && bcSfFilterConfig.custom.show_sale_circle) {
        var itemSaleLabelHtml = (bcSfFilterConfig.label.sale.size > 7) ? bcSfFilterTemplate.largeSaleLabelHtml : bcSfFilterTemplate.smallSaleLabelHtml;
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
    } else {
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');
    }

    // Add soldOut label
    if (soldOut && bcSfFilterConfig.custom.show_sold_out_circle) {
        var itemSoldOutHtml = (bcSfFilterConfig.label.sold_out.size > 9) ? bcSfFilterTemplate.largeSoldOutLabelHtml : bcSfFilterTemplate.smallSoldOutLabelHtml;
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutHtml);
    } else {
        itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
    }

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (data.title != '')  {
        itemPriceHtml += '<p class="grid-link__meta">';
        if (onSale) {
            itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
            itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</s> ';
        }
        if (priceVaries) {
            itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min, this.moneyFormat));
        } else {
            itemPriceHtml += onSale ? '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price + '</span>' : '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
            itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        }
        if(data.price_min > 0)
        {
            itemPriceHtml += ' ' + $(".nullsHidden").val() + '</p>';//You need to edit here
        }
        else
        {
            itemPriceHtml += ' </p>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb when user select "Collection" filter option
BCSfFilter.prototype.buildBreadcrumb = function(data) {
    var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml.replace(/{{itemSelected}}/g, data);
    jQ(this.selector.breadcrumb).html(breadcrumbHtml);
};

BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
    jQ('#bc-sf-filter-total-product').html(data.total_product + ' products');
  
  	theme.equalHeights();
  	theme.productImageGallery();

  	window.innerShiv=function(){function t(t,e,i){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(i)?t:e+"></"+i+">"}var e,i,n=document,a="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(r,o){if(!e&&(e=n.createElement("div"),e.innerHTML="<nav></nav>",i=1!==e.childNodes.length)){for(var s=n.createDocumentFragment(),d=a.length;d--;)s.createElement(a[d]);s.appendChild(e)}if(r=r.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,t),e.innerHTML=(s=r.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+r+"</table>":r,s=s?e.getElementsByTagName(s[1])[0].parentNode:e,o===!1)return s.childNodes;for(var d=n.createDocumentFragment(),l=s.childNodes.length;l--;)d.appendChild(s.firstChild);return d}}(),function(){window.SPR=function(){function t(){}return t.shop=Shopify.shop,t.host="//productreviews.shopifycdn.com",t.version="v4",t.api_url=t.host+"/proxy/"+t.version,t.asset_url=t.host+"/assets/"+t.version,t.badgeEls=[],t.reviewEls=[],t.elSettings={},t.$=void 0,t.extraAjaxParams={shop:t.shop},t.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},t.loadStylesheet=function(){var t,e;return e=document.createElement("link"),e.setAttribute("rel","stylesheet"),e.setAttribute("type","text/css"),e.setAttribute("href",this.asset_url+"/spr.css"),e.setAttribute("media","screen"),t=document.getElementsByTagName("head")[0],t.appendChild(e)},t.initRatingHandler=function(){return t.$(document).on("mouseover mouseout","form a.spr-icon-star",function(e){var i,n,a;return i=e.currentTarget,a=t.$(i).attr("data-value"),n=t.$(i).parent(),"mouseover"===e.type?(n.find("a.spr-icon:lt("+a+")").addClass("spr-icon-star-hover"),n.find("a.spr-icon:gt("+(a-1)+")").removeClass("spr-icon-star-hover")):n.find("a.spr-icon").removeClass("spr-icon-star-hover")})},t.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(t){return function(e,i){var n;return n=t.$(i).attr("data-id"),t.elSettings[n]={},t.elSettings[n].reviews_el="#"+(t.$(i).attr("data-reviews-prefix")?t.$(i).attr("data-reviews-prefix"):"reviews_"),t.elSettings[n].form_el="#"+(t.$(i).attr("data-form-prefix")?t.$(i).attr("data-form-prefix"):"form_")}}(this))},t.loadProducts=function(){return this.$.each(this.reviewEls,function(t){return function(e,i){var n,a,r;return a=t.$(i).attr("data-id"),n=t.$(i).attr("data-autoload"),"false"!==n?(r=t.$.extend({product_id:a,version:t.version},t.extraAjaxParams),t.$.get(t.api_url+"/reviews/product",r,t.productCallback,"jsonp")):void 0}}(this))},t.loadBadges=function(){var t,e,i,n,a;if(i=this.$.map(this.badgeEls,function(t){return function(e){return t.$(e).attr("data-id")}}(this)),i.length>0){for(e=7,a=[];(t=i.splice(0,e)).length>0;)n=this.$.extend(this.extraAjaxParams,{product_ids:t}),a.push(this.$.get(this.api_url+"/reviews/badges",n,this.badgesCallback,"jsonp"));return a}},t.pageReviews=function(t){var e,i,n;return n=this.$(t).data("product-id"),i=this.$(t).data("page"),e=this.$.extend({page:i,product_id:n},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",e,this.paginateCallback,"jsonp"),!1},t.submitForm=function(t){var e;return e=this.$(t).serializeObject(),e=this.$.extend(e,this.extraAjaxParams),e=this.$.param(e),e=e.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:e,success:this.formCallback,beforeSend:function(t){return function(){return t.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(t){return function(){return t.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},t.reportReview=function(t){var e;return confirm("Are you sure you want to report this review as inappropriate?")&&(e=this.$.extend({id:t},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",e,this.reportCallback,"jsonp")),!1},t.toggleReviews=function(t){var e;return e=this.$("#shopify-product-reviews[data-id='"+t+"']"),e.find(".spr-reviews").toggle()},t.toggleForm=function(t){var e;return e=this.$("#shopify-product-reviews[data-id='"+t+"']"),e.find(".spr-form").toggle()},t.setRating=function(t){var e,i,n;return e=this.$(t).parents("form"),n=this.$(t).attr("data-value"),i=this.$(t).parent(),e.find("input[name='review[rating]']").val(n),this.setStarRating(n,i)},t.setStarRating=function(t,e){return e.find("a:lt("+t+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),e.find("a:gt("+(t-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},t.badgesCallback=function(e){var i;return i=e.badges,t.$.map(t.badgeEls,function(e){var n;return n=t.$(e).attr("data-id"),void 0!==i[n]?(t.$(e).replaceWith(i[n]),t.$(document).trigger("spr:badge:loaded",{id:n})):void 0})},t.productCallback=function(e){var i;return i=e.remote_id.toString(),t.renderProduct(i,e.product),t.renderForm(i,e.form),t.renderReviews(i,e.reviews)},t.renderProduct=function(t,e){return this.$.map(this.reviewEls,function(i){return function(n){return t===i.$(n).attr("data-id")?(i.$(n).html(innerShiv(e,!1)),i.$(document).trigger("spr:product:loaded",{id:t})):void 0}}(this))},t.renderForm=function(t,e){var i;return i=this.$(this.elSettings[t].form_el+t),i.html(e),this.$(document).trigger("spr:form:loaded",{id:t})},t.renderReviews=function(e,i){var n;return n=t.$(t.elSettings[e].reviews_el+e),n.html(i),t.$(document).trigger("spr:reviews:loaded",{id:e})},t.formCallback=function(e){var i,n,a,r;return r=e.status,a=e.remote_id,n=e.form,i=t.$(t.elSettings[a].form_el+a),i.html(n),"failure"===r&&t.initStarRating(i),"success"===r&&t.$("#shopify-product-reviews[data-id='"+a+"'] .spr-summary-actions-newreview").hide(),t.$(document).trigger("spr:form:"+r,{id:a})},t.initStarRating=function(t){var e,i,n;return n=t.find("input[name='review[rating]']"),n&&n.val()?(i=n.val(),e=t.find(".spr-starrating"),this.setStarRating(i,e)):void 0},t.paginateCallback=function(e){var i,n;return n=e.remote_id.toString(),i=e.reviews,t.renderReviews(n,i)},t.reportCallback=function(e){var i;return i="#report_"+e.id,t.$(i).replaceWith("<span class='spr-review-reportreview'>"+t.$(i).attr("data-msg")+"</span>")},t.loadjQuery=function(e){return t.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return t.$=jQuery.noConflict(!0),e()})},t.loadScript=function(t,e){var i;return i=document.createElement("script"),i.type="text/javascript",i.readyState?i.onreadystatechange=function(){return"loaded"===i.readyState||"complete"===i.readyState?(i.onreadystatechange=null,e()):void 0}:i.onload=function(){return e()},i.src=t,document.getElementsByTagName("head")[0].appendChild(i)},t.loadjQueryExtentions=function(t){return t.fn.serializeObject=function(){var e,i;return e={},i=this.serializeArray(),t.each(i,function(){return e[this.name]?(e[this.name].push||(e[this.name]=[e[this.name]]),e[this.name].push(this.value||"")):e[this.name]=this.value||""}),e}},t}(),function(){return SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}.call(this);
}

function BCSfFilterCallback (result) {
	bcsffilter.hideLoading();
	bcsffilter.afterGetFilterData(result, result.event_type);
};

// Request API for Filter Data
BCSfFilter.prototype.getFilterData = function (eventType) {
	var _this = this;
	_this.showLoading();
	
	// Prepare params
	var params = mergeObject({}, this.queryParams);
	params.collection_scope = parseInt(this.collectionId);
	if (eventType == "history") {
		if (History.getState().data.hasOwnProperty("param") && History.getState().data.param.hasOwnProperty("collection_scope")) {
			params.collection_scope = this.collectionId = parseInt(History.getState().data.param.collection_scope);
		} else {
			params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
		}
	}
	if (this.getSettingValue("general.availableAfterFiltering") == true) {
		params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
		params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
	} else {
		params.product_available = this.productAvailable;
		params.variant_available = this.variantAvailable;
	}
	if (typeof this.collectionTags !== "undefined" && this.collectionTags !== null) {
		params.tag = this.collectionTags[0];
	}
	params.build_filter_tree = (typeof eventType !== "undefined" && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
	params.check_cache = (this.checkExistFilterOptionParam() === false && params["page"] == 1 && params["sort"] == this.defaultSorting && params["limit"] == this.getSettingValue("general.limit")) ? true : false; // Only cache when request doest not have Refine By, "page" param equal to 1 and "sort" param equal to default sorting
	// Set data back to queryParams
	this.queryParams = params;

	this.queryParams["callback"] = "BCSfFilterCallback";
	this.queryParams["event_type"] = eventType;
	var script = document.createElement("script");
	//Set the Type
	script.type = "text/javascript";
	var timestamp = new Date().getTime();
	//Set the source to the URL the JSON Service.
	script.src = bcSfFilterConfig.shop.apiUrl + "?t=" + timestamp + "&" + jQ.param(_this.queryParams);
	script.async = true;
	script.addEventListener("error", function (e) {
		this.remove();
		// Error handling here 
		_this.showError("Oops, we cannot fetch products at this moment. Please try again later.");
	});
	//Append the script element to the HEAD section.
	document.getElementsByTagName("head")[0].appendChild(script);
	script.onload = function () {
		this.remove();
	};
};

// Customize data to suit the theme
BCSfFilter.prototype.prepareProductData = function(data) {
  for (var k in data) {
    var optionsArr = [];
    for (var i in data[k]["options_with_values"]) {
      optionsArr.push(data[k]["options_with_values"][i]["name"]);
    }
    data[k]["options"] = optionsArr;
    for (var i in data[k]["variants"]) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]["variants"][i];

      // New API
      if (typeof variant.hasOwnProperty("merged_options")) {
        var variantOptions = variant["merged_options"];
        for (var j in variantOptions) {
          var temp = variantOptions[j].split(":");
          data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
          data[k]["variants"][i]["option_" + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
      }
      // Old API
      else {
        for (var j in variant) {
          if (j.indexOf("option_") != -1) {
            data[k]["variants"][i]["option" + count] = variant[j];
            variantOptionArr.push(data[k]["variants"][i][j]);
            count ++;
          }
        }
      }
      data[k]["variants"][i]["compare_at_price"] = parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
      data[k]["variants"][i]["price"] = parseFloat(data[k]["variants"][i]["price"]) * 100;
      data[k]["variants"][i]["options"] = variantOptionArr;
    }
  }

  return data;
};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
